<div style="position: relative; margin-bottom: 20px; padding-top: 40px">
  <sbnb-close class="close-btn" [border]="true" mat-dialog-close></sbnb-close>

  <sbnb-reservation-details></sbnb-reservation-details>

  <div fxLayoutAlign="end center" style="padding-top: 20px">
    <sbnb-button mat-dialog-close label="Close"></sbnb-button>
  </div>
</div>
